import { TableCell, TableRow, IconButton, Chip } from '@mui/material'
import React from 'react'
import CircleCheckbox from 'src/Component/CircleCheckbox'
import eyeIcon from 'src/assets/icons/eyeIcon.png'
import deleteIcon from 'src/assets/icons/deleteIcon.png'
import dayjs from 'dayjs'

type DataRowProps = {
  id: number
  date: string
  title: string
  price: string
  unit: string
  isActive: boolean
  selected: boolean
  onViewDetailsClick: (id: number) => void
  onDeleteClick: (id: number) => void
  onEditClick: (id: number) => void
  onSelect: (id: number) => void
}
const DataRow = ({
  id,
  date,
  title,
  price,
  unit,
  selected,
  onViewDetailsClick,
  onDeleteClick,
  onSelect,
  onEditClick,
  isActive
}: DataRowProps) => {
  return (
    <TableRow
      hover
      
      tabIndex={-1}
    
    >
      <TableCell padding='checkbox'>
      
        <CircleCheckbox checked={selected} onChange={(checked) => onSelect(id)} />
      </TableCell>
      
      <TableCell>{ dayjs(date).format('DD MMM YYYY, hh:mm a') }</TableCell>
      <TableCell onClick={() => onEditClick(id)}>
        {' '}
        <span
          style={{
            borderBottom: '1px solid white',
            cursor: 'pointer',
          }}
        >
          {title}
        </span>{' '}
      </TableCell>
      <TableCell>{price}</TableCell>
      <TableCell>{unit}</TableCell>
      <TableCell>{
        isActive ? <Chip label='Active' color='success' /> : <Chip label='In-Active' color='error' /> }</TableCell>
      <TableCell align='center'>
        <IconButton onClick={() => onViewDetailsClick(id)}>
          {' '}
          <img src={eyeIcon} alt='eyeIcon' />{' '}
        </IconButton>
        <IconButton onClick={() => onDeleteClick(id)}>
          {' '}
          <img src={deleteIcon} alt='deleteIcon' />{' '}
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default DataRow
